var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnsreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 81,
    viewBox: "0 0 73 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3 32.8C10.1 34.5 12.1 37.9 12.1 37.9L35 0L12.7 15.6C11.4 16.5 10.3 17.7 9.5 19.1C7.4 23.4 7.4 28.4 9.3 32.8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.300004 45.2C0.800004 52.5 4.5 59.3 10.3 63.7L35 80.9C35 80.9 19.5 58.6 6.5 36.4C5.2 34.1 4.3 31.5 3.9 28.8C3.7 27.6 3.7 26.4 3.9 25.2C3.6 25.8 2.9 27.1 2.9 27.1C1.6 29.8 0.700004 32.7 0.200004 35.7C-0.0999959 38.9 -0.0999959 42.1 0.300004 45.2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3 48.2C62.5 46.5 60.5 43.1 60.5 43.1L37.6 80.9L60 65.4C61.3 64.5 62.4 63.3 63.2 61.9C65.2 57.6 65.3 52.6 63.3 48.2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4 35.7C71.9 28.4 68.2 21.6 62.4 17.2L37.7 0C37.7 0 53.2 22.3 66.2 44.5C67.5 46.8 68.4 49.4 68.8 52.1C69 53.3 69 54.5 68.8 55.7C69.1 55.1 69.8 53.8 69.8 53.8C71.1 51.1 72 48.2 72.5 45.3C72.7 42 72.7 38.9 72.4 35.7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.1C10.3 17.7 11.3 16.5 12.7 15.6L35 0L12.1 37.8C12.1 37.8 10.1 34.4 9.3 32.7C7.4 28.4 7.4 23.4 9.5 19.1ZM0.300004 45.2C0.800004 52.5 4.5 59.3 10.3 63.7L35 80.9C35 80.9 19.5 58.6 6.5 36.4C5.2 34.1 4.3 31.5 3.9 28.8C3.7 27.6 3.7 26.4 3.9 25.2C3.6 25.8 2.9 27.1 2.9 27.1C1.6 29.8 0.700004 32.7 0.200004 35.7C-0.0999959 38.9 -0.0999959 42.1 0.300004 45.2ZM63.3 48.2C62.5 46.5 60.5 43.1 60.5 43.1L37.6 80.9L60 65.4C61.3 64.5 62.4 63.3 63.2 61.9C65.2 57.6 65.3 52.6 63.3 48.2ZM72.3 35.8C71.8 28.5 68.1 21.7 62.3 17.3L37.7 0C37.7 0 53.2 22.3 66.2 44.5C67.5 46.8 68.4 49.4 68.8 52.1C69 53.3 69 54.5 68.8 55.7C69.1 55.1 69.8 53.8 69.8 53.8C71.1 51.1 72 48.2 72.5 45.3C72.7 42 72.7 38.9 72.3 35.8Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.7,
    height: 80.9,
    fill: "white"
  })))));
}
export default SvgEnsreact;